import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Register } from '../../_models/register';
import { Product } from '../../_models/product';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

import * as _ from "lodash";

@Component({
  selector: 'app-setting-returns',
  templateUrl: './setting-returns.component.html',
  styleUrls: ['./setting-returns.component.css']
})

export class SettingReturnsComponent implements OnInit {
  description: string;
  config: string;
  days: string;
  activeProduct: Product;
  activeProducts: any = [];  //Get all products of the Account owner
  returnProducts: any = [];
  reasonList: any;
  returnForDeleteProduct: any;
  returnForDelete: any;
  day: any = [];
  statusText1: string;
  statusText2: any;
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText7: string = "";
  statusText8: string = "";
  statusText9: string = "";
  statusText10: string = "";
  statesList: any;

  constructor(private alertService: AlertService, private g: Globals, private router: Router, private http: HttpClient, public user: User, private api: ApiIntegration, public register: Register) {
    this.reasonSettingsList();
    this.productList();
    this.g.page = "Return Settings";
    this.api.getDays("1", "ACCOUNT_OWNER", this.user.accountOwnerId, "RETURN_DAYS").subscribe((data: any = []) => {
      this.day = data;
      //this.days = this.day.config;
      //this.days = _.cloneDeep(this.day.config);
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  reasonSettingsList() {
    this.api.getValues("1", "ACCOUNT_OWNER", this.user.accountOwnerId, "REASON").subscribe((data: any) => {
      this.reasonList = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  productList() {
    this.api.getReturnableProductList(this.user.accountOwnerId, "1", "NO").subscribe((data: any) => {
      this.returnProducts = data.getProductsResponses;
      this.getProductsList();
    }, err => {
      this.alertService.error('Error', err);

    });
  }

  getProductsList() {
    this.api.getProductsList(this.user.accountOwnerId, "1").subscribe((data: any) => {
      this.activeProducts = _.cloneDeep(data.getProductsResponses);
      for (let rp of this.returnProducts) {
        for (let ap of this.activeProducts) {
          if (ap.productName === rp.productName) {
            let index = this.activeProducts.indexOf(ap);
            this.activeProducts.splice(index, 1);
          }
        }
      }
    }, err => {
      this.alertService.error('Error', err);

    });
  }

  ngOnInit() {
  }

  typeReason() {
    this.statusText1 = "";
    if (this.config == '' || this.config === null || this.config === undefined || this.config === 'undefined') {
      this.statusText1 = 'Reason should not be empty';
      this.g.loaderDisplay = "";
      this.g.loaderDisplay = "";
      return false;
    }
  }

  submitReturn() {
    this.statusText1 = "";
    if (this.config == '' || this.config === null || this.config === undefined || this.config === 'undefined') {
      this.statusText1 = 'Reason should not be empty';
      this.g.loaderDisplay = "";
      this.g.loaderDisplay = "";
      return false;
    }

    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createTripleSetConfigs', {
      "child": "REASON",
      "config": this.config,
      "control": "ACCOUNT_OWNER",
      "organizationId": 1,
      "parent": this.user.accountOwnerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Settings', 'Returned Successfully');

          this.config = "";
          this.reasonSettingsList();
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      )
  }

  selectProduct() {
    this.statusText2 = "";
    if (this.activeProduct === null || this.activeProduct === undefined) {
      this.statusText2 = 'Please select product';
      this.g.loaderDisplay = "";
      return false;
    }
  }

  submitProduct() {
    this.g.loaderDisplay = "display";
    this.statusText2 = "";
    if ( this.activeProduct === null || this.activeProduct === undefined || this.config === 'activeProduct') {
      this.statusText2 = 'Please select product';
      this.g.loaderDisplay = "";
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateAsReturnOrNonReturn', {
      "accountOwnerId": this.user.accountOwnerId,
      "id": this.activeProduct.productId,
      "isReturnable": "NO",
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Product', 'submit Successfully');

          this.productList();
          console.log('Removed the product from the list');
          this.activeProduct = null;
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      )
  }

  submitDay(d) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createTripleSetConfigs', {
      "child": "RETURN_DAYS",
      "config": d.config,
      "control": "ACCOUNT_OWNER",
      "organizationId": 1,
      "parent": this.user.accountOwnerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Submit', 'Day Successfully');
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      )
  }

  deleteReturnProduct() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateAsReturnOrNonReturn', {
      "id": this.returnForDeleteProduct.productId,
      "accountOwnerId": this.user.accountOwnerId,
      "isReturnable": "YES",
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('NonReturnable Product', 'Deleted Successfully');

          this.productList();
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      )
  }

  selectedDeleteProduct(productReturn) {
    this.returnForDeleteProduct = productReturn;
  }

  deleteReturn() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteTripleSetConfig', {
      "id": this.returnForDelete.id,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Return', 'Deleted Successfully');

          this.reasonSettingsList();
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  selectedDeleteReturn(returnn) {
    this.returnForDelete = returnn;
  }
}
